import { RootState } from '../store';

export const selectIsDarkMode = (state: RootState) =>
  state.displaySettings.isDarkMode;

export const selectIsRTL = (state: RootState) => state.displaySettings.isRtl;

export const selectIsSidebarOpen = (state: RootState) =>
  state.displaySettings.isSidebarOpen;
